export default {"src":"/uk/_next/static/media/folderIcon.aec6088e.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};